<template>
  <div>

    <div v-if="isLoad==false" class="col 12">
      <loading-block  :loading="!isLoad"/>
      <h2>{{ LoadMessage}}</h2>
    </div>

    <div  :class="{'row col-12 alert alert-danger':( err_field && err_field.includes('services')),'row col-12':!(err_field && err_field.includes('services'))}" v-if="isLoad && form.type=='developer'">
      <div class="col-12 col-md-6 col-lg-6 form-group  ">
        <label>Услуги</label>
      </div>
      <div class="col-12 col-md-6 col-lg-6  form-group">
        <select class="form-control" multiple v-model="services_data">
          <option v-for="(service,service_index) in form.services" :key="service_index" :value="service.last_id">{{ service.name }}</option>
        </select>
      </div>
    </div>
    <div v-if="isLoad"   v-for="(question,question_key) in form.questions"
        :key="question_key">





      <div   :class="{'row col-12 alert alert-danger':(question.name && err_field && err_field.includes(question.name)),'row col-12':!(question.name && err_field && err_field.includes(question.name))}">
        <div class="col-12 col-md-6 col-lg-6 form-group  ">
          <label>{{ question.title}}</label>
          <p v-if="question.type=='image' && file_form[question.name] && file_form[question.name].file &&  file_form[question.name].file.url">
            <br>
            <img class="img img-thumbnail" :src="file_form[question.name].file.url" />

          </p>

        </div>

        <div class="col-12 col-md-6 col-lg-6  form-group">
          <input type="number" v-if="question.type=='number'" class="col-12 form-control" v-model="custom_form[question.name]"    >
          <input type="file" accept="image/*" @change="uploadImageItem($event,question.name)"  v-if="question.type=='image'"  >

          <input type="file"   @change="uploadFileItem($event,question.name)"  v-if="question.type=='file'"  >
          <p v-if="question.type=='file' && file_form[question.name] && file_form[question.name].file &&  file_form[question.name].file.url"><a :href="file_form[question.name].file.url" target="_blank">{{ file_form[question.name].file.name }}</a></p>
          <select v-if="question.type=='select' && question.options && question.options.length>0" class="col-12 form-control" v-model="custom_form[question.name]" >
            <option v-for="(option,option_key) in question.options"
                :key="option_key">{{ option}}</option>
          </select>


          <input  v-if="question.type=='text'" type="text" class="col-12 form-control"  v-model="custom_form[question.name]"    >
          <textarea v-if="question.type=='textarea'" class="col-12 textarea form-control" v-model="custom_form[question.name]" ></textarea>

        </div>
      </div>




    </div>
  </div>
</template>

<script>
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";

export default {
  name: "FormVerification",
  props: {

    form:Object,




  },
  components: {LoadingBlock},
  data() {

    var app = this;

    return {
      "isLoad":false,
      "LoadMessage":"Идет загрузка",
      "custom_form":{},
      "file_form":{

      },
      "services_data":[],
      "map_data":{

      },

      "err_field":[],
    }
  },
  mounted() {
    var app=this;
    if(app.form && app.form.questions && app.form.questions.length>0){
      var custom_form={};
      var map_data={};

      app.form.questions.forEach(function(elem){

        custom_form[elem.name]="";

      });


      app.custom_form=custom_form;
      app.map_data=map_data;
      app.disableLoad();
    }
  },
  methods:{
    findAddress(name_field){
      var app=this;
      if(!(app.map_data[name_field])){
        return false;
      }
      var addr=app.map_data[name_field];
      if(addr.length<2){
        return false;
      }
      var custom_form=app.custom_form;
      Api.loadCoordinatesByAddr(addr,function(data){

        // if(!(custom_form[name_field]['data'])){
        //   custom_form[name_field]['data']={};
        // }
        // if(!(custom_form[name_field]['data']['addrs'])){
        //   custom_form[name_field]['data']['addrs']=[];
        // }
        app.map_data[name_field]="";
        custom_form[name_field]['data']['addrs'].push(data.addr);
        app.custom_form=custom_form;
      })
    },
    uploadFileItem(event,name_field){
      var app=this;

      let data = new FormData();
      data.append("file",event.target.files[0]);

      // let config = {
      //   header : {
      //     'Content-Type' : 'image/png'
      //   }
      // }
      app.setLoad("Загрузка файла...");
      var file_form=app.file_form;
      Api.loadFile(data,function(data){

        app.disableLoad();
        var new_data={};
        new_data["file"]=data.file;
        file_form[name_field]=new_data;
        //  app.newItem.photos.push(data.file.url);

        app.file_form=file_form;

      })
    },
    uploadImageItem(event,name_field){
      var app=this;

      let data = new FormData();
      data.append("image",event.target.files[0]);

      // let config = {
      //   header : {
      //     'Content-Type' : 'image/png'
      //   }
      // }
      var file_form=app.file_form;
      app.setLoad("Загрузка изображения...");

      Api.loadImage(data,function(data){
        app.disableLoad();
        var new_data= {};
        new_data["file"]=data.file;
        file_form[name_field]=new_data;
        file_form[name_field]=data;
        //  app.newItem.photos.push(data.file.url);

        app.file_form=file_form;


        app.disableLoad();


      })
    },
    disableLoad(){
      this.isLoad=true;
    },
    setLoad(message){
      this.isLoad=false;
      this.LoadMessage=message;
    },
    saveForm(){
      var app=this;
      var result={};
      var err_field=[];

      if(app.form.type=="developer" && app.services_data.length==0){
        err_field.push("services");
      }

      app.form.questions.forEach(function(elem){
         if(elem.type!="image" && elem.type!="file" && elem.type!="location"){
          if(!(app.custom_form && app.custom_form[elem.name] && app.custom_form[elem.name].length>0)){


            err_field.push(elem.name);
          }
        } else {
          if(!(app.file_form[elem.name] && app.file_form[elem.name].file  &&  app.file_form[elem.name].file.url)){
            err_field.push(elem.name);
          }
        }


      });

      app.err_field=err_field;


      if(err_field.length==0){
        result=app.custom_form;
        if(app.form.type=="developer") {
          result["services"] = app.services_data;
        }
        if(Object.entries(app.file_form).length>0){
          for (const [key, value] of Object.entries(app.file_form)) {
            result[key]=value;

          }
        }
        return result;
      }

    },

  }
}
</script>

<style scoped>

</style>